/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */
 
const AUTH0_CLIENT_ID = 'OxRZ4kmOUD2f2PE2yLfZU9oMnq7SdkA3';
const AUTH0_DOMAIN = 'dryeyerescue-dev.us.auth0.com';
const AUTH0_CALLBACK_URL = window.location.href;
const GET_ENDPOINT = 'https://wavoloxiee.execute-api.us-east-1.amazonaws.com/prod/patients';

// initialize auth0 lock
const lock = new Auth0Lock(AUTH0_CLIENT_ID, AUTH0_DOMAIN, {
  auth: {
    params: {
      scope: 'openid email',
    },
    responseType: 'token id_token',
  },
});

// Variant image functionality is now handled directly in theme.js
// This ensures it works with the theme's built-in variant change system

// Debug: Check if settings are being passed correctly
document.addEventListener('DOMContentLoaded', function() {
  console.log('DOM loaded, checking settings...');
  
  // Check if we can find the section settings
  const productSection = document.querySelector('[data-section-type="product"]');
  if (productSection) {
    const settings = productSection.getAttribute('data-section-settings');
    if (settings) {
      const parsedSettings = JSON.parse(settings);
      console.log('Product section settings:', parsedSettings);
      console.log('enableVariantImageFiltering:', parsedSettings.enableVariantImageFiltering);
      console.log('filterImagesOnLoad:', parsedSettings.filterImagesOnLoad);
    } else {
      console.log('No section settings found');
    }
  } else {
    console.log('No product section found');
  }
});

// Sticky sidebar functionality for collection pages
document.addEventListener('DOMContentLoaded', function() {
  const sidebar = document.querySelector('.layout__section--secondary');
  const productList = document.querySelector('.product-list--with-sidebar');
  
  if (sidebar && productList) {
    // Add smooth scrolling behavior
    sidebar.style.scrollBehavior = 'smooth';
    
    // Add visual feedback when scrolling
    let ticking = false;
    
    function updateSidebarPosition() {
      if (!ticking) {
        requestAnimationFrame(function() {
          const rect = sidebar.getBoundingClientRect();
          const isSticky = rect.top <= 20;
          
          if (isSticky) {
            sidebar.classList.add('is-sticky');
          } else {
            sidebar.classList.remove('is-sticky');
          }
          
          ticking = false;
        });
        ticking = true;
      }
    }

    // Listen for scroll events
    window.addEventListener('scroll', updateSidebarPosition, { passive: true });
    
    // Add CSS for sticky state
    const style = document.createElement('style');
    style.textContent = `
      .layout__section--secondary.is-sticky {
        box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
        border-radius: 8px;
        transition: box-shadow 0.3s ease;
      }
      
      .layout__section--secondary.is-sticky .card {
        border-radius: 8px;
      }
      
      .layout__section--secondary.is-sticky .card__section--tight {
        background: rgba(255, 255, 255, 0.95);
        backdrop-filter: blur(10px);
        border-radius: 6px;
        margin: 2px;
      }
    `;
    document.head.appendChild(style);
  }
});


// Free Shipping Progress Bar Functionality
document.addEventListener('DOMContentLoaded', function() {
  function updateFreeShippingProgress() {
    const progressBar = document.querySelector('.free-shipping-progress__fill');
    const progressAmount = document.querySelector('.free-shipping-progress__amount');
    const progressContainer = document.querySelector('.free-shipping-progress');
    
    if (!progressBar || !progressAmount) return;
    
    const progress = parseInt(progressBar.getAttribute('data-progress')) || 0;
    
    console.log('Progress bar found:', progressBar);
    console.log('Progress value:', progress);
    
    // Set the width directly with !important
    progressBar.style.setProperty('width', progress + '%', 'important');
    
    console.log('Width set to:', progress + '%');
    console.log('Actual width:', progressBar.style.width);
    
    // Update color based on progress
    if (progress >= 100) {
      progressBar.style.background = `linear-gradient(90deg, var(--progress-complete-color, #28a745) 0%, var(--progress-complete-color, #28a745) 100%)`;
    } else {
      progressBar.style.background = `linear-gradient(90deg, var(--progress-color, #ff6228) 0%, var(--progress-color, #ff6228) 100%)`;
    }
    
    // Add animation class for smooth transition
    progressBar.classList.add('animate');
    
    // Remove animation class after animation completes
    setTimeout(() => {
      progressBar.classList.remove('animate');
    }, 800);
    
    // Update progress amount text if cart total changes
    if (window.cart && window.cart.total_price) {
      const threshold = window.cart.free_shipping_threshold || 50000; // Default $500 in cents
      const remaining = threshold - window.cart.total_price;
      
      if (remaining > 0) {
        const remainingFormatted = new Intl.NumberFormat('en-US', {
          style: 'currency',
          currency: 'USD',
          minimumFractionDigits: 0,
          maximumFractionDigits: 0
        }).format(remaining / 100);
        
        progressAmount.textContent = `${remainingFormatted} more for free shipping`;
      }
    }
  }
  
  // Update progress bar when cart changes
  function handleCartUpdate() {
    // Wait a bit longer for the DOM to update
    setTimeout(updateFreeShippingProgress, 300);
  }
  
  // Listen for cart updates
  document.addEventListener('cart:updated', handleCartUpdate);
  document.addEventListener('cart:refresh', handleCartUpdate);
  document.addEventListener('product:added', handleCartUpdate);
  
  // Initial update
  updateFreeShippingProgress();
  
  // Update progress bar on cart drawer open
  const cartDrawer = document.querySelector('.mini-cart');
  if (cartDrawer) {
    const observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'aria-hidden') {
          if (cartDrawer.getAttribute('aria-hidden') === 'false') {
            setTimeout(updateFreeShippingProgress, 200);
          }
        }
      });
    });
    
    observer.observe(cartDrawer, {
      attributes: true,
      attributeFilter: ['aria-hidden']
    });
  }
  
  // Also observe changes to the mini-cart content
  const miniCartContent = document.querySelector('.mini-cart__content');
  if (miniCartContent) {
    const contentObserver = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.type === 'childList') {
          // Check if progress bar was added/updated
          const progressBar = document.querySelector('.free-shipping-progress__fill');
          if (progressBar) {
            setTimeout(updateFreeShippingProgress, 100);
          }
        }
      });
    });
    
    contentObserver.observe(miniCartContent, {
      childList: true,
      subtree: true
    });
  }
});



// Simple Description Collapse with jQuery
$(document).ready(function() {
  var $header = $('.product-block-list__item--description .card__header');
  var $section = $('.product-block-list__item--description .card__section');
  
  if ($header.length && $section.length) {
    // Check if collapse is enabled (you can control this via CSS class)
    if ($('body').hasClass('description-collapse-enabled')) {
      // Hide content initially

      // $section.hide();
      
      // Click header to toggle
      $header.on('click', function() {
        $section.slideToggle();
        $header.toggleClass('expanded');
      });
    }
  }
});

$(document).ready(function() {
  var $header = $('.product-block-list__item--tab .card__header');
  var $section_bottom = $('.product-block-list__item--tab .card__section');
  
  if ($header.length && $section_bottom.length) {
    // Check if collapse is enabled (you can control this via CSS class)
    if ($('body').hasClass('description-collapse-enabled')) {
      // Hide content initially
      $section_bottom.hide();
      
      // Click header to toggle
      $header.on('click', function() {
        $section_bottom.slideToggle();
        $section_bottom.toggleClass('expanded');
      });
    }
  }
});

// Enhanced Tab Analytics and User Experience
document.addEventListener('DOMContentLoaded', function() {
  // Track tab interactions for analytics
  function trackTabInteraction(tabTitle, action) {
    if (typeof gtag !== 'undefined') {
      gtag('event', 'tab_interaction', {
        'event_category': 'product_tabs',
        'event_label': tabTitle,
        'value': action === 'open' ? 1 : 0
      });
    }
  }
  
  // Add smooth scrolling to tabs when opened
  function addSmoothScrolling() {
    const collapsibleButtons = document.querySelectorAll('.card__collapsible-button');
    
    collapsibleButtons.forEach(button => {
      button.addEventListener('click', function() {
        const isExpanded = this.getAttribute('aria-expanded') === 'true';
        
        if (!isExpanded) {
          // Track opening
          const tabTitle = this.querySelector('.card__title').textContent;
          trackTabInteraction(tabTitle, 'open');
          
          // Smooth scroll to tab after a short delay
          setTimeout(() => {
            this.scrollIntoView({
              behavior: 'smooth',
              block: 'start'
            });
          }, 300);
        } else {
          // Track closing
          const tabTitle = this.querySelector('.card__title').textContent;
          trackTabInteraction(tabTitle, 'close');
        }
      });
    });
  }
  
  // Add keyboard navigation between tabs
  function addKeyboardNavigation() {
    const collapsibleButtons = document.querySelectorAll('.card__collapsible-button');
    
    collapsibleButtons.forEach((button, index) => {
      button.addEventListener('keydown', function(e) {
        if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
          e.preventDefault();
          
          let targetIndex;
          if (e.key === 'ArrowDown') {
            targetIndex = (index + 1) % collapsibleButtons.length;
          } else {
            targetIndex = (index - 1 + collapsibleButtons.length) % collapsibleButtons.length;
          }
          
          collapsibleButtons[targetIndex].focus();
        }
      });
    });
  }
  
  // Initialize enhanced features
  addSmoothScrolling();
  addKeyboardNavigation();
});
